import { Autocomplete, Stack, TextField, Typography } from "@mui/material"

export function RegimeSection({ regimes, selectedRegime, onSelect, disabled }) {
    return (
        <Stack spacing={1.5}>
            <Stack spacing={0.5}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Maintenance Regime
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    What Regime would you like to work out costs for?
                </Typography>
            </Stack>
            <Autocomplete
                data-cy="regime-selector"
                options={regimes}
                value={selectedRegime}
                onChange={handleChange}
                getOptionLabel={getRegimeLabel}
                isOptionEqualToValue={isRegimeEqual}
                renderInput={renderRegimeInput}
                disabled={disabled}
                fullWidth
            />
        </Stack>
    )

    function handleChange(__, value) {
        onSelect(value)
    }
}

function getRegimeLabel(regime) {
    return regime?.label?.replaceAll("Live:", "").replaceAll("Ready:", "").trim() ?? ""
}

function isRegimeEqual(option, value) {
    return option?.id === value?.id
}

function renderRegimeInput(params) {
    return <TextField {...params} label="Maintenance Regime" placeholder="Select Maintenance Regime" />
}
